import { useEffect, useRef, useState } from 'react';
import { useWebSocket } from '../../context/WebSocketContext';
import { watchLiveRefresh } from '../../hooks/liveRefresh';

const intervals = {'1m':60,'5m':300,'15m':900,'30m':1800,'1H':3600,'4H':14400,'1D':86400,'1W':604800};
const append = (rows, quote, interval) => {
  const price = (Number(quote?.bid)+Number(quote?.ask))/2;
  const stamp = Date.parse(quote?.last_update)/1000;
  if(!Number.isFinite(price)||price<=0||!Number.isFinite(stamp))return rows;
  const time=Math.floor(stamp/interval)*interval, last=rows.at(-1);
  if(last&&time<last.time)return rows;
  if(last&&time===last.time)return [...rows.slice(0,-1),{...last,high:Math.max(last.high,price),low:Math.min(last.low,price),close:price}];
  return [...rows,{time,open:price,high:price,low:price,close:price,volume:0}].slice(-1441);
};

export const useVirtualHistory = (symbol, timeframe, enabled, price) => {
  const {isConnected}=useWebSocket();
  const [state,setState]=useState({key:'',candles:[],error:'',loading:false});
  const latest=useRef(price);latest.current=price;
  const key=`${symbol}:${timeframe}`;
  useEffect(()=>{
    if(!enabled)return;
    let active=true;
    const controller=new AbortController();
    const load=async()=>{
      try {
        const response=await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/trader/virtual-history?${new URLSearchParams({symbol,timeframe})}`,{signal:controller.signal,headers:{Authorization:`Bearer ${localStorage.getItem('trader_token')}`}});
        if(!response.ok)throw new Error('Simulated price history unavailable');
        const data=await response.json();
        if(active)setState({key,candles:append(data.candles,latest.current,intervals[timeframe]),error:'',loading:false});
      }catch(error){if(active)setState(previous=>({...previous,key,error:error.message,loading:false}));}
    };
    setState({key,candles:[],error:'',loading:true});load();
    const stop=watchLiveRefresh(load,0);
    return()=>{active=false;controller.abort();stop();};
  },[key,symbol,timeframe,enabled,isConnected]);
  useEffect(()=>{
    if(enabled)setState(previous=>previous.key!==key||previous.loading?previous:{...previous,candles:append(previous.candles,latest.current,intervals[timeframe])});
  },[enabled,key,timeframe,price?.last_update,price?.bid,price?.ask]);
  return state.key===key?state:{candles:[],error:'',loading:enabled};
};